export default __webpack_public_path__ + "static/media/bg-img.51ce3e71.png";